import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shared-page" }
const _hoisted_2 = { class: "centeredContentBox" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "logoWrap" }, [
  /*#__PURE__*/_createTextVNode("ZB"),
  /*#__PURE__*/_createElementVNode("span", { id: "logoEdgeWrap" }, [
    /*#__PURE__*/_createElementVNode("span", { id: "logoEWrap" }, "E"),
    /*#__PURE__*/_createTextVNode("dge")
  ]),
  /*#__PURE__*/_createTextVNode(" ")
], -1)
const _hoisted_4 = { class: "textLarge bottomSpaceDouble" }
const _hoisted_5 = {
  class: "button",
  type: "button",
  value: "Home"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CwePageHeader = _resolveComponent("CwePageHeader")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CwePageHeader, { authenticationRequired: true }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('page_not_found')), 1),
        _createVNode(_component_router_link, { to: {name:'Dashboard'} }, {
          default: _withCtx(() => [
            _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.$t('return_home')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}